import Image from 'next/image';

import { akamaiLoader } from '@/utils/akamaiLoader';

import type { ContentfulServiceFragment } from '@/graphql/contentful/api';
import { generateDataTestId } from '@/lib/tests';

import * as S from './Service.styles';

interface ServicesProps extends ContentfulServiceFragment {
  className?: string;
}

export const Service = ({ className, heading, media, url }: ServicesProps) => {
  return (
    <S.Wrapper className={className} href={url ?? '#'}>
      {media && (
        <S.ImageWrapper>
          <Image
            {...generateDataTestId('banner', 'image')}
            alt={media.title || 'Banner'}
            data-test-id='ServiceImg'
            height={0}
            loader={akamaiLoader}
            sizes='100vw'
            src={media.url ?? ''}
            style={{ width: '100%', height: 'auto' }}
            width={0}
          />
        </S.ImageWrapper>
      )}
      <S.Label data-test-id='ServiceLabel'>{heading}</S.Label>
    </S.Wrapper>
  );
};
